import React, { Component } from "react";
import { connect } from "react-redux";
import localization from "../../Localization/Localization.json";
import "./Home.scss";
import { FaCommentDots, FaArchive } from "react-icons/fa";
import { FiTrendingUp } from "react-icons/fi";
import FinanceChart from "../../components/FinanceChart/FinanceChart";
import { Link, Redirect } from "react-router-dom";
import { Button, Carousel } from "antd";
import CarImg from "../../assets/car2.png";
import sliderHero from "../../assets/slider-hero.png";
import searchImg from "../../assets/search.svg";
import clipboardImg from "../../assets/clipboard.svg";
import schedulingImg from "../../assets/scheduling.svg";
import transferImg from "../../assets/transfer.svg";
import Features from "../../components/Features/Features";
import DownloadApp from "../../components/DownloadApp/DownloadApp";
import InterestingNumbers from "../../components/InterestingNumbers/InterestingNumbers";
import AdvantagesSection from "../../components/AdvantagesSection/AdvantagesSection";
import Footer from "../../components/FooterWide/FooterWide";
import BrandsHome from "../../components/BrandsHome/BrandsHome";

class Home extends Component {
  state = {
    homeCard: [
      {
        name: "مجموع الطلبات",
        value: 33,
      },
    ],
  };
  // componentDidMount() {
  //   if (true) {
  //     <Redirect to="/orders" />;
  //   }
  //   this.props.history.push("/orders");
  // }

  render() {
    const { currentLang, currentUser } = this.props;
    return (
      <div className="home-wrapper">
        <div className="home-slider">
          <Carousel>
            <img src={sliderHero} alt="" />
            {/* <img
              src="https://cdn.syarah.com/syarah/online/hero/1689522747-597.webp?v=moh4"
              alt=""
            />
            <img
              src="https://cdn.syarah.com/syarah/online/hero/1689522747-597.webp?v=moh4"
              alt=""
            /> */}
          </Carousel>
        </div>
        <div className="container">
          <div className="home-content-wrapper">
            <div
              className="home-section-wrapper service-section-wrapper"
              id="service-section"
            >
              <h1 className="page-title">خدمات ماي كار</h1>
              <div className="service-list-holder">
                <Link to="/cars" className="service-card-holder">
                  <img src={CarImg} alt="" />
                  <h5 className="service-card--title">طلب سيارة</h5>
                </Link>
                <Link to="/cars" className="service-card-holder">
                  <img src={searchImg} alt="" />
                  <h5 className="service-card--title">ابحث عن سيارة</h5>
                </Link>
                <Link
                  to={currentUser ? "/orders" : "/cars"}
                  className="service-card-holder"
                >
                  <img src={clipboardImg} alt="" />
                  <h5 className="service-card--title">طلباتي</h5>
                </Link>
                <Link to="/transfer-ownership" className="service-card-holder">
                  <img src={transferImg} alt="" />
                  <h5 className="service-card--title"> نقل ملكية</h5>
                </Link>
              </div>
            </div>
            <BrandsHome />
          </div>
        </div>
        {/* <InterestingNumbers /> */}
        <DownloadApp />
        <Features />
        <AdvantagesSection />
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
  currentUser: state.user.currentUser,
});

//   const LoginWithRouter = withRouter(Login);
export default connect(mapStateToProps)(Home);
